export const SIZES = {
  large: 'large',
  medium: 'medium',
  small: 'small',
  tiny: 'tiny',
};

export const TYPES = {
  visa: 'visa',
  americanExpress: 'american-express',
  discover: 'discover',
  mastercard: 'master-card',
  paypal: 'paypal',
  boleto: 'boleto',
  stripe: 'stripe',
  unionpay: 'unionpay',
  jcb: 'jcb',
  diners: 'diners',
};

export const ALL_TYPES = 'all';

export const GAPS = {
  'spacing-3-xs': 'spacing-3-xs',
  'spacing-xs': 'spacing-xs',
};
